import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@src/components/shadcn/dropdown-menu';
import {SidebarFooter, SidebarMenuButton} from '@src/components/shadcn/sidebar';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faMemo,
  faUser,
  faArrowRightFromBracket,
  faArrowLeft,
} from '@fortawesome/pro-light-svg-icons';
import redirectViaSubmit from '@src/util/redirectViaSubmit';
import {NavItem} from './types';

type SimpleLink = {
  absoluteRoot: string;
  relativePath: string;
  label: string;
};

const NavFooter = ({
  accountNavItems,
  catererInfo,
  backToAdminItem,
  logoutItem,
}: {
  accountNavItems: NavItem[];
  catererInfo: {email: string; name: string};
  backToAdminItem: SimpleLink | undefined;
  logoutItem: SimpleLink | undefined;
}) => {
  return (
    <SidebarFooter>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton asChild>
            <div className="cursor-pointer bg-peppercorn-50 h-16 p-4 rounded flex items-center justify-between">
              <section className="flex items-center gap-2">
                <div className="bg-ezGreen rounded h-8 w-8 flex justify-center items-center">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="text-ezGreen bg-white rounded-full w-4"
                  />
                </div>
                <div className="flex justify-center items-start flex-col">
                  <span className="text-base text-textPrimary font-normal">
                    {catererInfo?.name}
                  </span>
                  <span className="text-xs text-peppercorn-400 font-normal">
                    {catererInfo?.email}
                  </span>
                </div>
              </section>
              <div className="flex flex-col">
                <FontAwesomeIcon className="text-xs text-textPrimary" icon={faChevronUp} />
                <FontAwesomeIcon className="text-xs text-textPrimary" icon={faChevronDown} />
              </div>
            </div>
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="rounded-lg w-56"
          align="end"
          sideOffset={-50}
          alignOffset={-180}
        >
          <p className="font-semibold text-sm text-popoverForeground p-2 h-8 m-0">My Account</p>
          <DropdownMenuSeparator />
          <div className="flex flex-col gap-3 p-3">
            {accountNavItems.map(({label, to}) => (
              <a
                key={to}
                href={to}
                className="flex justify-start gap-2 items-center text-popoverForeground"
              >
                <FontAwesomeIcon className="text-sm text-textPrimary" icon={faMemo} />
                <span className="text-sm text-textPrimary">{label}</span>
              </a>
            ))}
            <DropdownMenuSeparator />
            {backToAdminItem && (
              <a
                href={`${backToAdminItem.absoluteRoot}${backToAdminItem.relativePath}`}
                className="flex justify-start gap-2 items-center text-popoverForeground"
              >
                <FontAwesomeIcon className="text-sm text-textPrimary" icon={faArrowLeft} />
                <span className="text-sm text-textPrimary">{backToAdminItem.label}</span>
              </a>
            )}
            {logoutItem && (
              <a
                href={`${logoutItem.absoluteRoot}${logoutItem.relativePath}`}
                className="flex justify-start gap-2 items-center text-popoverForeground"
                onClick={e => {
                  e.preventDefault();
                  redirectViaSubmit(
                    `${logoutItem.absoluteRoot}${logoutItem.relativePath}`,
                    'DELETE'
                  );
                }}
              >
                <FontAwesomeIcon
                  className="text-sm text-textPrimary"
                  icon={faArrowRightFromBracket}
                />
                <span className="text-sm text-textPrimary">{logoutItem.label}</span>
              </a>
            )}
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarFooter>
  );
};

export default NavFooter;
